import { render, staticRenderFns } from "./tab-slide-config.vue?vue&type=template&id=a1d45578&scoped=true"
import script from "./tab-slide-config.vue?vue&type=script&lang=js"
export * from "./tab-slide-config.vue?vue&type=script&lang=js"
import style0 from "./tab-slide-config.vue?vue&type=style&index=0&id=a1d45578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d45578",
  null
  
)

export default component.exports